import { Typography } from '@mui/material'
import React from 'react'

export const MovingText = ({ text ,variant,color,width }) => {
    return (
        <Typography
            variant={variant || "body1"}
            sx={{
                display: "inline-block", 
                whiteSpace: "nowrap", 
                overflow: "hidden", 
                textOverflow: "ellipsis",
                width:width || "90%",
                position: "relative", 
                color:color || "inherit",

                "&:hover span": {
                    animation: "scrollText 5s linear infinite",
                },

                "@keyframes scrollText": {
                    "0%": { transform: "translateX(0%)" },
                    "100%": { transform: "translateX(-100%)" },
                }
            }}
        >
            <span style={{ display: "inline-block" }}>
                {text}
            </span>
        </Typography>
    )
}
